import { api_GET, api_POST, api_PUT } from './_api';

const ManutencaoOrdemColeta_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ManutencaoOrdemColeta/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ManutencaoOrdemColeta/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    AtualizarDadosColeta: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`ManutencaoOrdemColeta/AtualizarColetas/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    AdicionaEnderecoExtraordinario: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`ManutencaoOrdemColeta/AdicionaEnderecoExtraordinario/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    FinalizarOrdemColetaManual: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ManutencaoOrdemColeta/FinalizarOrdemDeColetaManual/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    TransbordoDeCarga: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`ManutencaoOrdemColeta/TransbordoDeCarga/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    TransferenciaDeColetasPendentes: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`ManutencaoOrdemColeta/TransferenciaDeColetasPendentes/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}
export default ManutencaoOrdemColeta_api;